import { render, staticRenderFns } from "./PricingTierSettings.vue?vue&type=template&id=604164a3&scoped=true&"
import script from "./PricingTierSettings.vue?vue&type=script&lang=js&"
export * from "./PricingTierSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604164a3",
  null
  
)

export default component.exports